import { WebviewId, WebviewPlugin } from '@gitlab-org/webview-plugin';
import { Logger } from '@gitlab-org/logging';
import { SocketIOWebViewTransport } from '@gitlab-org/webview-transport-socket-io';
import { Transport } from '@gitlab-org/webview-transport';
import { WebviewUriProviderRegistry } from '../common/webview';
import { createFastifyHttpServer, createFastifySocketIoPlugin } from './http';
import { createWebviewPlugin, WebviewHttpAccessInfoProvider } from './webview';

export async function setupHttp(
  plugins: WebviewPlugin[],
  uriProviderRegistry: WebviewUriProviderRegistry,
  transportRegistry: Set<Transport>,
  logger: Logger,
): Promise<void> {
  const server = await initializeHttpServer(
    plugins.map((x) => x.id),
    logger,
  );

  uriProviderRegistry.register(new WebviewHttpAccessInfoProvider(server.addresses()?.[0]));
  transportRegistry.add(new SocketIOWebViewTransport(server.io));
}

async function initializeHttpServer(webviewIds: WebviewId[], logger: Logger) {
  const { shutdown: fastifyShutdown, server } = await createFastifyHttpServer({
    plugins: [
      createFastifySocketIoPlugin(),
      createWebviewPlugin({
        webviewIds,
      }),
      {
        plugin: async (app) => {
          app.get('/', () => {
            return { message: 'Hello, world!' };
          });
        },
      },
    ],
    logger,
  });

  const handleGracefulShutdown = async (signal: string) => {
    logger.info(`Received ${signal}. Shutting down...`);
    server.io.close();
    await fastifyShutdown();
    logger.info('Shutdown complete. Exiting process.');
    process.exit(0);
  };

  process.on('SIGTERM', handleGracefulShutdown);
  process.on('SIGINT', handleGracefulShutdown);

  return server;
}
